import { QueryCache, QueryClient } from '@tanstack/vue-query'
import { onUnmounted } from 'vue'

const errorHandlers = []

const queryCache = new QueryCache({
  onError (error, query) {
    if (error.code === 'ECONNABORTED') return
    // This is a global error handler for queries if we need it
    let handled = false
    for (const fn of errorHandlers) {
      try {
        if (fn(error, query)) {
          handled = true
        }
      }
      catch (handlerError) {}
    }
    if (!handled) {
      console.error('query error', {
        queryKey: query.queryKey,
        code: error.code,
        message: error.message,
      })
    }
  },
})

export function onQueryError (fn) {
  onUnmounted(onQueryCacheError(fn))
}

function onQueryCacheError (fn) {
  errorHandlers.push(fn)
  return () => {
    const idx = errorHandlers.indexOf(fn)
    if (idx !== -1) errorHandlers.splice(idx, 1)
  }
}

export default new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      // I mainly put this here because on logout it tries to refetch a load of stuff multiple times (places, users)
      // (even though I have the "enabled" option to only do that if it's logged in
      retry: false,
    },
  },
})
